import { useAuthorizedInstallersDashboardContext } from '@authorizedInstaller/contexts';
import { TextField } from '@mui/material';

const General = () => {
    const { installerRequest } = useAuthorizedInstallersDashboardContext();
    return (
        <div className="grid grid-cols-2 gap-4 py-6">
            <TextField
                disabled
                label="First Name"
                value={installerRequest?.user.first_name}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Last Name"
                value={installerRequest?.user.last_name}
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Company Name"
                value={installerRequest?.user.company_name}
                className="col-span-2"
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
            <TextField
                disabled
                label="Distributor"
                value={`${installerRequest?.distributor.company_name}`}
                className="col-span-2"
                slotProps={{
                    inputLabel: {
                        shrink: true,
                    },
                }}
            />
        </div>
    );
};

export { General };
